export const voiceCalls = {
  "head": {
    "title": "Chiamate",
    "subtitle": "Le chiamate a cui ha risposto il tuo centralino."
  },
  "stats": {
    "all": "chiamata | chiamate",
    "spoken": "con risposta | con risposta",
    "inTotal": "in totale"
  },
  "toolbar": {
    "searchLabel": "Cerca",
    "searchPlaceholder": "Numero di chi ha chiamato…",
    "clear": "Cancella la ricerca",
    "showLabel": "Mostra",
    "showAll": "Tutte le chiamate",
    "showSpoken": "Solo con risposta",
    "showRecorded": "Solo registrate"
  },
  "notice": {
    "noRecording": "Le chiamate non vengono registrate.",
    "noRecordingHow": "Attiva «Registra le chiamate» nelle impostazioni del tuo centralino: da quel momento potrai ascoltarle e trascriverle qui."
  },
  "empty": {
    "title": "Non ti ha ancora chiamato nessuno",
    "text": "Quando qualcuno chiamerà il tuo numero, la chiamata comparirà qui con chi ha chiamato, quanto è durata e cosa voleva.",
    "filteredTitle": "Nessuna chiamata con questo filtro",
    "filteredText": "Prova a togliere la ricerca o i filtri qui sopra."
  },
  "item": {
    "notSpoken": "Nessuno ha parlato",
    "unknownCaller": "Numero nascosto",
    "linkSent": "Link di prenotazione inviato",
    "play": "Ascolta la registrazione",
    "pause": "Pausa",
    "showTranscript": "Vedi la trascrizione",
    "hideTranscript": "Nascondi la trascrizione",
    "transcribe": "Trascrivi e riassumi",
    "transcribing": "Trascrizione in corso…",
    "noRecordingShort": "Questa chiamata non è stata registrata",
    "viewReservation": "Vedi la prenotazione",
    "noSummary": "Questa chiamata non ha un riassunto.",
    "copy": "Copia il numero",
    "copied": "Copiato"
  },
  "errors": {
    "load": "Non è stato possibile caricare le chiamate.",
    "play": "Non è stato possibile riprodurre la registrazione.",
    "transcribe": "Non è stato possibile richiedere la trascrizione."
  },
  "table": {
    "call": "Chiamata",
    "reservation": "Prenotazione",
    "listing": "Alloggio",
    "summary": "Riassunto",
    "duration": "Durata",
    "date": "Data"
  }
};
